const Divider = () => (
  <div
    className="hidden my-10 md:block"
    style={{ border: '1px solid #fff', opacity: '0.2' }}
  />
)

export default Divider
